var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L14 6M14 6L10 2M14 6H10C5.58172 6 2 9.58172 2 14M34 34L30 38M30 38L34 42M30 38H34C38.4183 38 42 34.4183 42 30M24.8343 24.8343C26.3989 25.5816 28.1506 26 30 26C36.6274 26 42 20.6274 42 14C42 7.37258 36.6274 2 30 2C23.3726 2 18 7.37258 18 14C18 15.8494 18.4184 17.6011 19.1657 19.1657M26 30C26 36.6274 20.6274 42 14 42C7.37258 42 2 36.6274 2 30C2 23.3726 7.37258 18 14 18C20.6274 18 26 23.3726 26 30Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapLight);
export default __webpack_public_path__ + "static/media/swap_light.fbe992f9ca65059d0401bb9ed0adce48.svg";
export { ForwardRef as ReactComponent };